export const siteData = {
  siteName: "CSSBuy Spreadsheet Brasil",
  domain: "cssbuy.biz",
  mainSite: "https://kaspreadsheet.com",
  year: 2026,
  heroTitle: "Melhor CSSBuy Spreadsheet 2026",
  heroSubtitle: "A maior coleção de CSSBuy Spreadsheet, links, Yupoo e guias de compra.",
  heroDescription: "Encontre os melhores links, planilhas e guias completos do CSSBuy.",

  benefits: [
    "Atualizado diariamente",
    "Links organizados por categoria",
    "Guias completos para iniciantes",
    "Comparações entre agentes de compra",
    "Dicas de segurança para compras internacionais",
  ],

  categoryCards: [
    { name: "Tênis", icon: "ri-footprint-line", query: "sneakers" },
    { name: "Jordan", icon: "ri-basketball-line", query: "jordan" },
    { name: "Nike", icon: "ri-check-double-line", query: "nike" },
    { name: "Yeezy", icon: "ri-star-line", query: "yeezy" },
    { name: "Designer", icon: "ri-vip-crown-line", query: "designer" },
    { name: "Streetwear", icon: "ri-t-shirt-line", query: "streetwear" },
    { name: "Football", icon: "ri-football-line", query: "football" },
    { name: "Acessórios", icon: "ri-glasses-line", query: "accessories" },
  ],

  comparisonTable: [
    { agent: "CSSBuy", taxa: "Baixa", tempo: "Rápido", suporte: "Excelente", nota: "9.4" },
    { agent: "Superbuy", taxa: "Média", tempo: "Bom", suporte: "Muito bom", nota: "8.8" },
    { agent: "Pandabuy", taxa: "Média", tempo: "Médio", suporte: "Bom", nota: "8.5" },
  ],

  faqItems: [
    {
      question: "O que é o CSSBuy Spreadsheet?",
      answer: "O CSSBuy Spreadsheet é uma planilha organizada com os melhores links de produtos, vendedores verificados, álbuns Yupoo e guias completos para facilitar suas compras internacionais através do agente CSSBuy. Nossa planilha é atualizada diariamente e contém milhares de itens organizados por categoria.",
    },
    {
      question: "Como usar o CSSBuy Spreadsheet?",
      answer: "Basta acessar nossa planilha, escolher a categoria desejada e copiar o link do produto. Cole o link no CSSBuy para adicionar ao seu carrinho. Nossos guias detalhados explicam cada etapa do processo de compra, envio e rastreamento.",
    },
    {
      question: "O CSSBuy Spreadsheet é atualizado com que frequência?",
      answer: "Nossa planilha CSSBuy Spreadsheet é atualizada diariamente com novos links, produtos e vendedores. Mantemos uma equipe dedicada que verifica constantemente a qualidade e disponibilidade dos links para garantir a melhor experiência.",
    },
    {
      question: "CSSBuy vs Pandabuy: qual é melhor?",
      answer: "O CSSBuy oferece taxas mais baixas, suporte em português e envio mais rápido para o Brasil. O Pandabuy tem uma interface mais moderna, mas taxas mais altas. Para compradores brasileiros, o CSSBuy geralmente oferece melhor custo-benefício e suporte mais próximo.",
    },
    {
      question: "É seguro comprar usando o CSSBuy Spreadsheet?",
      answer: "Sim! Todos os links em nosso CSSBuy Spreadsheet são verificados manualmente. Além disso, o CSSBuy oferece proteção ao comprador, fotos de controle de qualidade e seguro de envio. Recomendamos sempre usar os links da nossa planilha para evitar vendedores não confiáveis.",
    },
    {
      question: "Como funciona o envio para o Brasil?",
      answer: "O CSSBuy oferece diversas opções de envio para o Brasil, incluindo linhas tax-free e triangle shipping para maior segurança. Nossa planilha inclui guias detalhados sobre as melhores opções de envio, estimativas de prazo e dicas para evitar taxas alfandegárias.",
    },
  ],

  articles: [
    {
      slug: "cssbuy-spreadsheet-guia-completo",
      title: "CSSBuy Spreadsheet 2026: Guia Completo com os Melhores Links",
      excerpt: "Descubra como usar o CSSBuy Spreadsheet para encontrar os melhores produtos, vendedores verificados e links Yupoo organizados por categoria.",
    },
  ],
};